var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcReviewKakao = function SvgIcReviewKakao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.667 9.583C1.667 5.536 5.547 2.5 10 2.5s8.334 3.036 8.334 7.083-3.88 7.084-8.334 7.084a10 10 0 0 1-1.288-.084l-2.417 1.61a.833.833 0 0 1-1.279-.856l.371-1.851c-2.197-1.244-3.72-3.389-3.72-5.903m6.667-3.75a.833.833 0 0 1 .833.834V12.5a.833.833 0 0 1-1.667 0V6.667a.833.833 0 0 1 .834-.834m.833 4.584a.83.83 0 0 1 .183-.521l1.667-2.084a.833.833 0 0 1 1.3 1.042l-1.25 1.563 1.25 1.562a.832.832 0 1 1-1.3 1.042L9.35 10.937a.83.83 0 0 1-.183-.52",
    clipRule: "evenodd"
  })));
};
export default SvgIcReviewKakao;